import React, { useCallback, useEffect, useState } from "react";
import {
  Dropdown,
  Icon,
  Menu as UIMenu,
} from 'semantic-ui-react';

import './blocks/reserved';

import { menu as data } from './blocks/data';
//import { menu as input } from './blocks/input';
import { menu as level } from './blocks/level';
import { menu as player } from './blocks/player';
import { menu as room } from './blocks/room';
import { menu as game } from './blocks/game';
import { menu as logic } from './blocks/logic';

export default function Menu({ codeView, addBlock, toggleCodeView, save }) {
  let menu = {
    player,
    room,
    level,
    game,
    data,
    logic,
  }

  const [ activeMenu, setActiveMenu ] = useState({ children: menu });

  const determineMenu = (e, { value }) => {
    let chain = [];
    do {
      let [ parent, ...rest ] = value.split('__')
      chain.push([chain.slice(-1)[0], parent].join('__').replace(/^__{1}/, ''))
      value = rest.join('__')
    } while(value);

    let active = menu;
    for (let x = 0; x < chain.length; x++) {
      active = ('children' in active) ? active.children[chain[x]] : active[chain[x]]
    }

    setActiveMenu(active);
  }

  const resetMenu = (e, data) => {
    setActiveMenu({ children: menu });
  }

  const menuHandler = useCallback((event) => {
    if (!(document.activeElement instanceof HTMLInputElement)) {
      let result = Object.keys(activeMenu.children).find(key => activeMenu.children[key].trigger.toLowerCase() === event.key.toLowerCase());
      if (result) {
        let elem = document.querySelector(`div[role="listbox"][name="${result}"], div[role="option"][name="${result}"]`)
        elem.click();
        if (!elem.classList.contains('dropdown')) {
          const event = new KeyboardEvent("keydown",{ 'key': 'Escape' });
          document.dispatchEvent(event);

        }
      }
    }
  }, [activeMenu]);

  useEffect(() => {
    document.addEventListener('keydown', menuHandler, false);
    return () => {
      document.removeEventListener('keydown', menuHandler, false);
    }
  }, [activeMenu, menuHandler]);

  const buildMenu = (obj) => {
    return Object.keys(obj).map((key) => {
      return (
        <Dropdown item openOnFocus onOpen={determineMenu} onClose={resetMenu} name={key} value={key} key={key} trigger={obj[key].name}>
          <Dropdown.Menu>
            { Object.keys(obj[key].children).map((child) => {
              if ('children' in obj[key].children[child]) {
                  return buildMenu({ [child]: obj[key].children[child]});
              } else {
                return <Dropdown.Item name={child} key={child} value={child} onClick={addBlock}>{obj[key].children[child].name}</Dropdown.Item>
              }
            })}
          </Dropdown.Menu>
        </Dropdown>
      )
    })
  }

  return (
    <UIMenu id="edit_menu" attached='top' inverted style={{ backgroundColor: '#333'}}>
      {buildMenu(menu)}
      <UIMenu.Menu position='right'>
        {codeView ?
          <UIMenu.Item
            icon
            name='Code'
            onClick={toggleCodeView}
          >
            <Icon name='code' />
          </UIMenu.Item>
          : ''}
        <UIMenu.Item
          icon
          name='Save'
          onClick={save}
        >
          <Icon name='save' />
        </UIMenu.Item>
      </UIMenu.Menu>
    </UIMenu>
  )
}
